<template>
  <b-modal id="error-modal" class="errormodal" title="錯誤訊息" hide-footer>
    <p class="errormodal__text">{{ errorMessage }}</p>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ErrorModal',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      errorMessage: 'errorMessage'
    })
  }
};
</script>

<style lang="scss" scoped>
.errormodal {
  color: $text-dark;
  &__text {
    padding: 30px 0 50px;
    color: $negative;
  }
}

::v-deep .modal-dialog {
  margin-top: 200px;
  color: $text-dark;
}
</style>
